import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

const useSearchSuggestions = () => {
  const getUserToken = localStorage.getItem("userId");
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      searchQuery &&
        fetch("/tradeindetails/search", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserToken}`,
          },
          body: JSON.stringify({
            searchText: searchQuery,
          }),
        })
          .then((response) => response.json())
          .then(({ data }) => {
            setSuggestions(data);
          })
          .catch((error) => {
            console.error(error);
          });
    }, 300);

    return () => {
      clearTimeout(delayDebounceFn);
    };
  }, [searchQuery]);

  // useEffect(() => {
  //   if (searchQuery === suggestions[0]?.headerExternalId) setSuggestions([]);
  // }, [suggestions]);

  const handleSearchInputChange = (event) => {
    const { value } = event.target;
    setSearchQuery(value);
  };

  const handleClearClick = () => {
    setSearchQuery("");
    setSuggestions([]);
  };

  const handleResultClick = (result) => {
    setSearchQuery(result.headerExternalId);
    history.push(`/TradeInDetails/${result.headerExternalId}`);
    setSuggestions([]);
    window.location.reload();
  };

  const handleSearchKeyDown = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      history.push(`/TradeInDetails/${searchQuery}`);
      window.location.reload();
    }
  };

  return {
    searchQuery,
    suggestions,
    handleSearchInputChange,
    handleClearClick,
    handleResultClick,
    handleSearchKeyDown,
  };
};

export default useSearchSuggestions;
